{
  "title": "Blade of Disaster",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "9th-level conjuration",
  "level": 9,
  "castingTime": "1 bonus action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a blade-shaped planar rift about 3 feet long in an unoccupied space you can see within range. The blade lasts for the duration. When you cast this spell, you can make up to two melee spell attacks with the blade, each one against a creature, loose object, or structure within 5 feet of the blade. On a hit, the target takes 4d12 force damage. This attack scores a critical hit if the number on the d20 is 18 or higher. On a critical hit, the blade deals an extra 8d12 force damage (for a total of 12d12 force damage).",
    "As a bonus action on your turn, you can move the blade up to 30 feet to an unoccupied space you can see and then make up to two melee spell attacks with it again.",
    "The blade can harmlessly pass through any barrier, including a Wall of Force."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
